module.exports = __webpack_public_path__ + "img/大件运输.864b7a45.jpeg";